<div class="card-body">
  <div class="row">
    @if (case) {
      <div class="col-12">
        <app-case-document-agent-file-uploader-v3 [case]="case">
        </app-case-document-agent-file-uploader-v3>
      </div>
    }
    <div class="col-12">
      <div class="row">
        <div class="col-12 col-lg-6">
          <app-case-document-request-list *ngIf="case" [case]="case"
                                          [clientRole]="'client'"
                                          (requestedDocuments)="reloadRequestedDocList('client')">
          </app-case-document-request-list>
          <app-case-document-request-list *ngIf="case?.joint_application" [case]="case"
                                          [clientRole]="'partner'"
                                          (requestedDocuments)="reloadRequestedDocList('partner')">
          </app-case-document-request-list>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="row">
        <!-- Document Upload / Document List-->
        <div class="col-12 col-lg-6">
          <app-case-client-requested-document-list-v3 #clientRequestedDocs *ngIf="case" [case]="case"
                                                      [clientRole]="'client'"
                                                      [documentableType]="documentableType"
                                                      [documentableId]="documentableId"
                                                      (filePreviewRequested)="previewFile($event)"
                                                      [inputType]="'default'"
                                                      (fileChangedClientRole)="addUpdatedFileToDocList($event, 'clientList', 'partner')">
          </app-case-client-requested-document-list-v3>
          <app-case-client-requested-document-list-v3 #partnerRequestedDocs *ngIf="case?.joint_application" [case]="case"
                                                      [clientRole]="'partner'"
                                                      [documentableType]="documentableType"
                                                      [documentableId]="documentableId"
                                                      (filePreviewRequested)="previewFile($event)"
                                                      [inputType]="'default'">
            (fileChangedClientRole)="addUpdatedFileToDocList($event, 'clientList', 'client')"
            (filePreviewRequested)="previewFile($event)">
          </app-case-client-requested-document-list-v3>
          <app-case-application-document-list-v3 *ngIf="case" [case]="case" [clientRole]="'client'"
                                                 [title]="'CASES.single.system_documents' | translate"
                                                 [documentableType]="documentableType"
                                                 [documentableId]="documentableId"
                                                 (filePreviewRequested)="previewFile($event)"
                                                 [inputType]="'default'">
          </app-case-application-document-list-v3>
          <app-case-court-document-list-v3 #courtClientDocs *ngIf="case" [case]="case"
                                           [clientRole]="'client'"
                                           [title]="'DOCUMENTS.court_documents' | translate"
                                           [documentableType]="documentableType"
                                           [documentableId]="documentableId"
                                           (filePreviewRequested)="previewFile($event)"
                                           [inputType]="'default'"
                                           (fileChangedClientRole)="addUpdatedFileToDocList($event, 'courtList', 'partner')">
          </app-case-court-document-list-v3>
          <app-case-court-document-list-v3 #courtPartnerDocs *ngIf="case?.joint_application" [case]="case"
                                           [clientRole]="'partner'"
                                           [title]="('DOCUMENTS.court_documents' | translate) + ' ' + ('DOCUMENTS.for_partner' | translate)"
                                           [documentableType]="documentableType"
                                           [documentableId]="documentableId"
                                           (filePreviewRequested)="previewFile($event)"
                                           [inputType]="'default'"
                                           (fileChangedClientRole)="addUpdatedFileToDocList($event, 'courtList', 'client')">
          </app-case-court-document-list-v3>
        </div>
        <!-- File Preview -->
        @if (previewFileUrl) {
          @if (previewFileType === 'object') {
            <div class="col-12 col-lg-6" style="height: auto; z-index: 1000">
              <div style="height: 100%">
                <div [ngClass]="{'height-50' : true, 'sticky' : previewIsSticky}" style="height: 100%">
                  <div class="d-flex justify-content-end w-100">
                    <small (click)="closeFilePreview()" style="cursor: pointer">{{ 'SHARED.close' | translate }}</small>
                  </div>
                  <object [data]="previewFileUrl" type="application/pdf" width="100%" height="100%">
                    <iframe [src]="previewFileUrl" width="100%" height="100%" style="border: none;">
                      <p>
                        Your browser does not support PDFs.
                        <a [href]="previewFileUrl">Download the PDF</a>
                      </p>
                    </iframe>
                  </object>
                </div>
              </div>
            </div>
          } @else {
            <div class="col-12 col-lg-6 d-flex justify-content-center">
              <div [ngClass]="{'height-50' : true, 'sticky' : previewIsSticky}">
                <div class="d-flex justify-content-end w-100">
                  <small (click)="closeFilePreview()" style="cursor: pointer">{{ 'SHARED.close' | translate }}</small>
                </div>
                <img [src]="previewFileUrl" alt="" class="img-fluid" style="max-height: 83vh">
              </div>
            </div>
          }
        }
      </div>
    </div>
  </div>
</div>
